import { RootState } from "../../../reducers";

export const getCouponPrecursor = (state: RootState) => state.couponsReducer.couponPrecursor || "";
export const getDeviceType = (state: RootState) => state.couponsReducer.deviceType || "";